import { render, staticRenderFns } from "./PelatihanSertifikat.vue?vue&type=template&id=774b7fbf&scoped=true"
import script from "./PelatihanSertifikat.vue?vue&type=script&lang=js"
export * from "./PelatihanSertifikat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "774b7fbf",
  null
  
)

export default component.exports